module.exports = __webpack_public_path__ + "myCeLogo.fa08423bfc0f1b364bc1.svg";


//////////////////
// WEBPACK FOOTER
// F:/PHAZP5152IS01-2/_work/98/s/src/assets/myCeLogo.svg
// module id = Hf6L
// module chunks = 0